module.exports = __webpack_public_path__ + "img/cloth.4cf3aa0a.png";